import React, { useRef } from 'react';

// WaterDropEffect Component
const WaterDropEffect = ({ containerRef }) => {
  const handleClick = (e) => {
    const container = containerRef.current;

    // Get position of the mouse click relative to the container
    const x = e.clientX - container.getBoundingClientRect().left;
    const y = e.clientY - container.getBoundingClientRect().top;

    // Create the water drop element
    const drop = document.createElement('div');
    drop.classList.add('water-drop');
    drop.style.left = `${x - 25}px`; // Center the drop at the click position
    drop.style.top = `${y - 25}px`; // Center the drop at the click position

    container.appendChild(drop);

    // Remove the water drop after animation ends
    setTimeout(() => {
      container.removeChild(drop);
    }, 800); // Duration of the animation (same as the CSS duration)
  };

  return (
    <div
      onClick={handleClick}
      className="absolute top-0 left-0 w-full h-full"
    >
      {/* The water drop elements will be added dynamically on click */}
    </div>
  );
};

export default WaterDropEffect;
